// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"d75cd826","769":"d75cd826"}[chunkId] + ".chunk.css";
};